<div *ngFor="let message of errorMessages$ | async" class="color--danger">
  {{ message }}
</div>
